import axios from 'axios';
import style from './Org.module.css';
import { Oval } from 'react-loader-spinner';
import Tile from '../../Dashboard/Tile/Tile';
import React, { useEffect, useState } from 'react';

const Org = () => {
  const curUser = JSON.parse(localStorage.getItem('curUser'));
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState([]);
  const [status, setStatus] = useState('All');
  const [severity, setSeverity] = useState('Low');

  useEffect(() => {
    function fetchData() {
      axios
        .get(`report/orgreports/${curUser.user._id}`, {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true,
        })
        .then((res) => {
          setReports(res.data.reports);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
    fetchData();
  }, [loading]);

  return (
    <div className={style.Dashboard}>
      <div className={style.Tile}>
        <div className={style.Heading}>
          <p>Reports</p>
          <p>These are reports that have submitted by users.</p>
        </div>
        {/* <div className={style.Selection}>
          <div>
            <p>Status</p>
            <select
              className='minimal'
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              disabled={!loading ? (reports.length === 0 ? true : false) : null}
            >
              <option>All</option>
              <option>Pending</option>
              <option>Completed</option>
            </select>
          </div>
          <div>
            <p>Severity</p>
            <select
              className='minimal'
              value={severity}
              onChange={(e) => setSeverity(e.target.value)}
              disabled={!loading ? (reports.length === 0 ? true : false) : null}
            >
              <option>Low</option>
              <option>High</option>
              <option>Critical</option>
            </select>
          </div>
        </div> */}
      </div>
      <div style={{ marginTop: '20px' }}>
        {!loading ? (
          reports.length !== 0 ? (
            reports.map((r) => {
              return (
                <div key={r._id}>
                  <h3 className={style.UserClick}>
                    Name : {r.user.name}, User ID:{r.user._id}
                  </h3>
                  <Tile report={r} userId={curUser.user._id} key={r._id} />
                </div>
              );
            })
          ) : (
            <div className={style.Center} style={{ fontWeight: '500' }}>
              No report found!
            </div>
          )
        ) : (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Org;
